.transaction-toast-progress {
  position: relative;
}

.transaction-toast-bar {
  position: absolute;
  pointer-events: none;
  left: -0.5rem;
  right: -0.5rem;
  bottom: -0.5rem;
  top: -0.5rem;
  background-color: gray;
  opacity: 0.25;
  transition: width 0.6s ease;
  max-width: calc(100% + 1rem);
}
